const items = [
  {
    title: "How to Book an Event",
    content: `
      Booking an event is simple! Browse our event calendar, select your desired event and date, fill in your details, and make the payment. You'll receive a confirmation email with all the details. Enjoy the event!
    `,
  },
  {
    title: "Types of Events We Offer",
    content: `
      We offer a variety of events including concerts, workshops, conferences, sports events, and theatre shows. Explore our categories to find something you'll love!
    `,
  },
  {
    title: "Frequently Asked Questions",
    content: `
      Can I cancel my booking? Yes, up to 48 hours before the event for a full refund. Group discounts are available for 10+ people. We accept major credit cards, PayPal, and bank transfers. Tickets are emailed upon booking.
    `,
  },
];

export default items;
